module.exports = __webpack_public_path__ + "media/SuiteApp/assets/svg/img/dollar-dfb402a229c86d18b6caa770e735b59f.svg";